import cn from 'classnames';

import { IConDefaultType } from '../types';

interface IEqualizerIconProps extends IConDefaultType {}

function EqualizerIcon({ color, className, size = 24, rotate, flip }: IEqualizerIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 9C4.55228 9 5 9.44772 5 10V14C5 14.5523 4.55228 15 4 15C3.44772 15 3 14.5523 3 14V10C3 9.44772 3.44772 9 4 9Z"
          fill="#00C3DD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6C8.55228 6 9 6.44772 9 7V17C9 17.5523 8.55228 18 8 18C7.44772 18 7 17.5523 7 17V7C7 6.44772 7.44772 6 8 6Z"
          fill="#00C3DD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C12.5523 3 13 3.44772 13 4V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V4C11 3.44772 11.4477 3 12 3Z"
          fill="#00C3DD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 8C16.5523 8 17 8.44772 17 9V15C17 15.5523 16.5523 16 16 16C15.4477 16 15 15.5523 15 15V9C15 8.44772 15.4477 8 16 8Z"
          fill="#00C3DD"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10C20.5523 10 21 10.4477 21 11V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V11C19 10.4477 19.4477 10 20 10Z"
          fill="#00C3DD"
        />
      </svg>
    </i>
  );
}

export default EqualizerIcon;
